
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0928b90d&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DetailsView.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DetailsView.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0928b90d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DetailsView.vue"),
  /* scopeId */
  "data-v-0928b90d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/views/DetailsView.vue
// module id = ./dev/src/views/DetailsView.vue
// module chunks = 0